module.exports = __webpack_public_path__ + "img/sleeve length.2a98b2d1.png";